<template>
  <div class="sidebar">
    <div class="sidebar-sticky">
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-link
            class="nav-link font-weight-bolder text-aegis-dk"
            :to="{ name: 'home' }"
            exact
          >
            AEGIS home
          </b-link>
        </li>
      </ul>

      <hr>
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-chart-bar"></i>
            MAIN
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'dashboard' }" exact>
            Dashboard
          </b-link>
        </li>
      </ul>

      <!-- Uploads section -->
      <!-- <hr v-if="inMyGroups([ADD GROUP NAMES])"> -->
      <hr>
      <!-- <ul class="nav flex-column" v-if="inMyGroups([ADD GROUP NAMES])"> -->
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0">
            <i class="fas fa-table"></i>
            Data Uploads
          </b-dropdown-header>
        </li>
        <!-- <li class="nav-item" v-if="inMyGroups([ADD GROUP NAMES])"> -->
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'vht-uploads' }">
            VHT Arm Product Distribution Data Upload
          </b-link>
        </li>
      </ul>
      <!-- Review Required -->
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement', 'Subject Final Status Workflow Editor', 'Action Move HHChange with Email Alert'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Review Required
          </b-dropdown-header>
        </li>
        <!-- Subject Withdrawal Requests -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'subject-withdrawal-request' }">
            Subject Withdrawal Requests
          </b-link>
        </li>
        <!-- move alert -->
        <li class="nav-item" v-if="inMyGroups(['Action Move HHChange with Email Alert'])">
          <b-link class="nav-link" :to="{ name: 'review-move-alert' }">
            Move Alert
          </b-link>
        </li>
        <!-- action taken -->
        <li class="nav-item" v-if="inMyGroups(['Action Move HHChange with Email Alert'])">
          <b-link class="nav-link" :to="{ name: 'review-action-taken' }">
            Action Taken
          </b-link>
        </li>
      </ul>

     <!-- Epi Analysis -->
     <hr v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Epi Analysis
          </b-dropdown-header>
        </li>

        <!-- Subject infected details table -->
        <li class="nav-item" v-if="inMyGroups(['Program PI', 'Data Manager', 'fhiClinical'])">
          <b-link
            class="nav-link"
            :to="{ name: 'metrics-subject-infected-details'}"
            exact
          >
            Subject infected details
          </b-link>
        </li>
      </ul>

      <!-- Epi Data -->
      <hr v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Epi Data
          </b-dropdown-header>
        </li>

        <!--Epi Data/Subject Enrollment Details -->
        <li class="nav-item" v-if="inMyGroups(['Program PI', 'Data Manager', 'fhiClinical'])">
          <b-link
            class="nav-link"
            :to="{ name: 'metrics-subject-enrollment-details'}"
            exact
          >
            Subject Enrollment Details
          </b-link>
        </li>
      </ul>

      <ul class="nav flex-column" v-if="user.is_superuser">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-users"></i>
            Admin
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'users' }">
            Users
          </b-link>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      drawer: true
    };
  },
  mounted() {
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters("user", ['inMyGroups']),
  },
  methods: {
    ...mapActions(["setBaseComponent", "clearAuthorizationToken"]),
    ...mapActions("user", ["setUser"]),
    goTo(route) {
      this.$router.push(route);
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style>
.sidebar {
  background-color: white;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  /* height: calc(100vh - 70px); */
  height: 100%;
  /* overflow-y: scroll; */
}
.sidebar .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  color: #666;
  line-height: 1.3;
  outline: 0;
  padding-left: 2.5rem;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.router-link-active {
  color: #333; /* #007bff; */
  font-weight: 500;
  background: #e1eef2;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.9rem;
  text-transform: uppercase;
  font-weight: 600;
}
</style>
